module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Bold.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Bold.eot
 ** module id = 342
 ** module chunks = 0
 **/